const configure = {
  apiUrl: " https://alapi.zithas.in/api",
  imgUrl: "https://alapi.zithas.in/application/public",
  nodeApi: "https://anapi.zithas.in/api",
  nodeImgApi: "https://anapi.zithas.in",
  exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",

  // apiUrl: "https://edemoapi.zithas.com/api",
  // imgUrl: "https://edemoapi.zithas.com/application/public",
  // nodeApi: "https://endemoapi.zithas.com/api",
  // nodeImgApi: "https://endemoapi.zithas.com",
  // exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",

  appUrl: "/",

  type: 2, // 192
};

export default configure;
